import apiClient from './apiClient';
import { setupRequestInterceptor, setupResponseInterceptor } from './interceptors';
import config from '@common/common/config';
import type { ApiResponse } from '@common/common/types/response';
import cookies from 'js-cookie';
import { ref } from 'vue';
import { setCookieForDay } from '@common/common/utils';
// import useClusterInAppStore from '@/stores/clusterInApp';

// 인터셉터 초기화
setupRequestInterceptor();
setupResponseInterceptor();

// 토큰 저장 변수
const token = ref<string | undefined>('');
const tokenApiEndPoint = 'for-easy-test/access-token';

// API 요청 함수
async function requestFitplus<T>(
    endpoint: string,
    method: 'get' | 'post' | 'put' | 'delete' | 'patch',
    data?: any,
): Promise<ApiResponse<T>> {
    let aipUrl = `${config.apiBaseUrl}${endpoint}`;
    token.value = cookies.get('tokenValue');

    // 로컬 개발 환경일 경우, 토큰이 없는 첫 번째 요청에서 처리
    if (config.isLocalDevelopment && (!token.value || token.value === '')) {
        try {
            // 첫 번째 요청: 토큰을 가져옴
            const authResponse = await apiClient({
                url: `${config.apiBaseUrl}${tokenApiEndPoint}`, // 인증 엔드포인트
                method: 'get',
                params: {
                    personNum: '8',
                },
            });

            token.value = authResponse.data;
            setCookieForDay('tokenValue', authResponse.data);
        } catch (error: any) {
            // alert 띄우기
            // console.error('토큰 가져오기 실패:', error.message || '알 수 없는 오류 발생');
            return Promise.reject(error.response?.data as ApiResponse<T>);
        }
    }

    const options = {
        url: aipUrl,
        method,
        params: method === 'get' || method === 'delete' ? data : null,
        data: method !== 'get' && method !== 'delete' ? data : null,
        headers: {
            Authorization: `Bearer ${token.value}`,
        },
    };

    return apiClient(options)
        .then(response => response.data as ApiResponse<T>)
        .catch(error => {
            // console.error('API 요청 에러:', error.message || '알 수 없는 오류 발생');
            // return Promise.reject(error.response?.data as ApiResponse<T>);
            throw error;
        });
}

async function requestFitplusRaw<T>(
    endpoint: string,
    method: 'get' | 'post' | 'put' | 'delete' | 'patch',
    data?: any,
): Promise<T> {
    let aipUrl = `${config.apiBaseUrl}${endpoint}`;
    token.value = cookies.get('tokenValue');

    // 로컬 개발 환경일 경우, 토큰이 없는 첫 번째 요청에서 처리
    if (config.isLocalDevelopment && (!token.value || token.value === '')) {
        try {
            // 첫 번째 요청: 토큰을 가져옴
            const authResponse = await apiClient({
                url: `${config.apiBaseUrl}${tokenApiEndPoint}`, // 인증 엔드포인트
                method: 'get',
                params: {
                    personNum: '8',
                },
            });

            token.value = authResponse.data;
            setCookieForDay('tokenValue', authResponse.data);
        } catch (error: any) {
            // alert 띄우기
            // console.error('토큰 가져오기 실패:', error.message || '알 수 없는 오류 발생');
            return Promise.reject(error.response?.data as ApiResponse<T>);
        }
    }

    const options = {
        url: aipUrl,
        method,
        params: method === 'get' || method === 'delete' ? data : null,
        data: method !== 'get' && method !== 'delete' ? data : null,
        headers: {
            Authorization: `Bearer ${token.value}`,
        },
    };

    return apiClient(options)
        .then(response => response.data as T)
        .catch(error => {
            // console.error('API 요청 에러:', error.message || '알 수 없는 오류 발생');
            // return Promise.reject(error.response?.data as ApiResponse<T>);
            throw error;
        });
}

export { requestFitplus, requestFitplusRaw };
